/* eslint-disable @typescript-eslint/no-explicit-any */

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IMessageListItemPresenterSchema } from '../../../chats/entities/message/MessageListItemPresenterSchema';
import { IUserListItemPresenterSchema } from '../../../chats/entities/user/UserListItemPresenterSchema';

export type TChatsOfferModel = IModel<IChatsOfferRequest, TChatsOfferResponse>;

export interface IChatsOfferRequest {
  /** Идентификатор объявления (cian_id) **/
  offerId?: number | null;
  /** Часовой пояс (смещение относительно UTC) **/
  tzOffset?: number | null;
}

export type TChatsOfferResponse = IChatsOfferResponse200 | IChatsOfferResponse400;

export interface IChatsOfferResponse200 extends IModelResponse<IChatsOfferResponse> {
  statusCode: 200;
}

export interface IChatsOfferResponse400 extends IModelResponse<IChatsOfferResponseError> {
  statusCode: 400;
}

export interface IChatsOfferResponse {
  /** Чат архивирован **/
  archived?: boolean | null;
  /** Чат архивирован мастер агентом **/
  archivedByMasterAgent?: boolean | null;
  /** Чат заблокирован **/
  blocked?: boolean | null;
  /** Чат заблокирован мастер агентом **/
  blockedByMasterAgent?: boolean | null;
  /** Пользователи, заблокировавшие чат **/
  blockedByUserIds?: number[] | null;
  /** Идентификатор чата **/
  chatId?: string | null;
  /** Таймстемп создания чата **/
  created?: number | null;
  /** Таймстемп создания чата(c точностью до ms) **/
  createdMs?: number | null;
  /** Дополнительная информация о чате **/
  data?: any | null;
  /** Чат удален **/
  deleted?: boolean | null;
  /** Последнее сообщение **/
  message?: IMessageListItemPresenterSchema | null;
  /** Заголовок чата **/
  title?: string | null;
  /** Тип чата **/
  type?: EType | null;
  /** Кол-во непрочитанных сообщений **/
  unread?: number | null;
  /** Таймстемп обновления чата **/
  updated?: number | null;
  /** Таймстемп обновления чата(с точностью до ms) **/
  updatedMs?: number | null;
  /** undefined **/
  users?: IUserListItemPresenterSchema[] | null;
}

export interface IChatsOfferResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IChatsOfferResponse | IChatsOfferResponseError;

export enum EType {
  /** Чат между двумя пользователями по карточке агента **/
  Agent = 'agent',
  /** Чат между двумя пользователями по объявлению **/
  Offer = 'offer',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IChatsOfferResponse): TResponse200;
  400(response: IChatsOfferResponseError): TResponse400;
}
